import { useState } from "react";
import { ButtonGroup, Button } from "react-bootstrap";

/**
 * ScoreBandSwitch
 *
 * Two-option segmented switch — "Score" / "Band" — matching the pill style
 * next to "Your last year's performance". Selected option is filled blue,
 * unselected stays white with a border. Built with react-bootstrap only.
 *
 * Usage:
 *   const [mode, setMode] = useState("score"); // "score" | "band"
 *   <ScoreBandSwitch value={mode} onChange={setMode} />
 *
 * Or fully uncontrolled (manages its own state internally):
 *   <ScoreBandSwitch onChange={(mode) => console.log(mode)} />
 */

const OPTIONS = [
  { value: "score", label: "Score" },
  { value: "band", label: "Band" },
];

const ACCENT = "#3B5BFF"; // match your app's primary blue if it differs

function ScoreBandSwitch({ value, onChange,isMobileView, defaultValue = "score" }) {
  const isControlled = value !== undefined;
  const [internalValue, setInternalValue] = useState(defaultValue);
  const current = isControlled ? value : internalValue;

  const handleSelect = (val) => {
    if (!isControlled) setInternalValue(val);
    onChange?.(val);
  };

  return (
    <ButtonGroup
      style={{
        border: `1px solid ${ACCENT}`,
        borderRadius: "999px",
        overflow: "hidden",
        padding: 2,
        background: "#fff",
        gap: '2px',
        minWidth: isMobileView ? '35%' : ''
      }}
    >
      {OPTIONS.map((opt) => {
        const active = current === opt.value;
        return (
          <Button
            key={opt.value}
            onClick={() => handleSelect(opt.value)}
            style={{
              border: "none",
              borderRadius: "999px",
              padding: "0.2rem 0.5rem",
              fontSize: "0.6rem",
              fontWeight: 600,
              backgroundColor: active ? ACCENT : "#fff",
              color: active ? "#fff" : "#374151",
              boxShadow: "none",
              transition: "background-color 0.15s ease, color 0.15s ease",
            }}
          >
            {opt.label}
          </Button>
        );
      })}
    </ButtonGroup>
  );
}

export default ScoreBandSwitch